import styled from 'styled-components';

export const StldCheckbox = styled.div`

    display: flex;
    align-items: center;
    & input {
        margin-right: .5rem;
        margin-left: .5rem;
        & after {
            border: var(--border-size-l) solid yellow;
            border-right: none;
            border-top: none;
        }
    }
`;

//marginLeft={'.5rem'}